import { render, staticRenderFns } from "./stockValueChartWidget.vue?vue&type=template&id=23121d43&"
import script from "./stockValueChartWidget.vue?vue&type=script&lang=js&"
export * from "./stockValueChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports